import { createFileRoute } from "@tanstack/react-router";
import AdminCodeDetailPage from "@/admin/pages/code-detail";

export const Route = createFileRoute("/admin/codes/$codeId")({
  component: AdminCodeDetailPage,
});
